import { call, put, takeLatest } from "redux-saga/effects";
import { callAPI, handleError, handleSuccess } from "../api/api";
import axios from "axios";
import { setLoaderAction, setNotificationAction } from "../reducers/mmymSlice";
import {
  addMaterialAction,
  deleteMaterialAction,
  getAllMaterialAction,
  setAddMaterialResponse,
  setAllMaterialAction,
  updateMaterialAction,
} from "../reducers/materialSlice";

/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

function* getAllMaterialSaga(): any {
  yield put(setLoaderAction(true));
  console.log("plans-try");
  try {
    const res = yield call<any>(callAPI, {}, "get", `client/materials`);
    if (res?.data) {
      yield put(setAllMaterialAction(res?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* addMaterialSaga(payload: any[]): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      "client/materials"
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddMaterialResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAddMaterialResponse(false));
  }
  yield put(setLoaderAction(false));
}

function* updateMaterialSaga(payload: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const {id} = payload?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      `client/materials`
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddMaterialResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAddMaterialResponse(false));
  }
  yield put(setLoaderAction(false));
}

function* deleteMaterialSaga(payload: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "delete",
      `client/materials/${payload?.payload?.id}`
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddMaterialResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAddMaterialResponse(false));
  }
  yield put(setLoaderAction(false));
}

export function* watchMaterial() {
  yield takeLatest<any>(getAllMaterialAction, getAllMaterialSaga);
  yield takeLatest<any>(addMaterialAction, addMaterialSaga);
  yield takeLatest<any>(updateMaterialAction,updateMaterialSaga);
  yield takeLatest<any>(deleteMaterialAction,deleteMaterialSaga);
}
